/* unplugin-vue-components disabled */
const __default__ = {
  mixins: [ModelValue(String)],
  props: {
    tabs: {type: Array, required: true},
    disabled: {type: Boolean, default: false},
    bordered: {type: Boolean, default: false}
  },
  data(){
    return {
      leave: false,
      height: undefined,
      on_resize: $utils.timers.debounce(this.setHeight, 500)
    }
  },
  methods: {
    setHeight(el){
      const item = el || this.$refs.items[0]
      if (item) this.height = `${item.offsetHeight}px`
    },
    onBeforeLeave(){
      this.leave = true
    },
    onAfterEnter(){
      this.leave = false
    },
    onBeforeEnter(el){
      this.setHeight(el)
    },
  }
}

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "a4b6351e-height": (_ctx.height)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__